import React from 'react'
import { FormattedMessage } from 'react-intl'

export const RESERVES_SLIDER_RANGE_LABEL = (
    <FormattedMessage
        id='reserves_slider.range_label'
        defaultMessage='Единиц резерва'
    />
)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReservesSlider/constants.jsx